import { ReactComponent as CheckListIcon } from 'assets/icons/listChecklist24.svg'
import cx from 'classnames'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { useCheckListToggle } from 'common/Prose/Toolbar/hooks/useCheckListToggle'
import { Button } from 'components/Button'
import { ButtonProps } from 'components/Button/Types'
import { observer } from 'mobx-react-lite'
import Styles from '../MobileToolbar.module.scss'

export const CheckListButton = observer((props: ButtonProps) => {
  const view = useEditorView()
  const { active, disabled, handleClick } = useCheckListToggle(view)

  return (
    <Button
      preventFocusOnPress
      variant="none"
      size="sm"
      aria-label="Turn into checklist"
      className={cx(Styles.button, {
        [Styles.buttonSelected]: active,
        [Styles.disabled]: disabled,
      })}
      onClick={handleClick}
      data-testid="mobile-toolbar-checklist-list-mark"
      {...props}
    >
      <CheckListIcon />
    </Button>
  )
})
